// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_AddItemInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/orders/add_item
 *
 * Add a service, product, additional service or combo item to an order.
 *
 * Fields:
 *   order_id              — int, required (so_orders PK)
 *   type                  — string, required ('service' | 'product' | 'additional_service' | 'combo')
 *   service_id            — int, optional (required when type='service')
 *   priority_id           — int, optional (required when type='service')
 *   product_id            — int, optional (required when type='product')
 *   additional_service_id — int, optional (required when type='additional_service')
 *   quantity              — int, optional (defaults to 1 in controller)
 *   parent_item_id        — int, optional (required when type='additional_service')
 *   combo_id              — int, optional (required when type='combo'; so_combos PK — NS 2026-0090:
 *                           sells the prepaid combo at the order franchise's price and creates
 *                           the purchase in the same transaction; feature `combos`)
 *   combo_purchase_id     — int, optional (type='service' only; so_combo_purchases PK — NS 2026-0090:
 *                           the new item is covered by the client's prepaid combo at add time,
 *                           price 0 + 1 pair reserved; refused = nothing is added; feature `combos`)
 *   qrcode                — string, optional
 *   attributes            — Orders_OrderItemAttributeInputRow[], optional
 *                           (saved via So_order_item_attribute_values_model::replaceForOrderItem)
 */
import type { Orders_OrderItemAttributeInputRow } from './Orders_OrderItemAttributeInputRow'
import { registerContract } from './validate'

export interface Orders_AddItemInput {
order_id: number
type: string
service_id?: number
priority_id?: number
product_id?: number
additional_service_id?: number
quantity?: number
parent_item_id?: number
combo_id?: number
combo_purchase_id?: number
qrcode?: string
attributes?: Orders_OrderItemAttributeInputRow[]
}

registerContract('Orders_AddItemInput', {
  order_id:              { type: 'number',  required: true },
  type:                  { type: 'string',  required: true },
  service_id:            { type: 'number',  required: false },
  priority_id:           { type: 'number',  required: false },
  product_id:            { type: 'number',  required: false },
  additional_service_id: { type: 'number',  required: false },
  quantity:              { type: 'number',  required: false },
  parent_item_id:        { type: 'number',  required: false },
  combo_id:              { type: 'number',  required: false },
  combo_purchase_id:     { type: 'number',  required: false },
  qrcode:                { type: 'string',  required: false },
  attributes: {
    type: 'array',
    required: false,
    items: {
      attribute_id: { type: 'number',  required: true },
      value:        { type: 'string',  required: false },
    },
  },
})
